import React, { Component } from "react";
import i18n from '../../i18n';
import Select from "react-select";
import { Button, Modal, Form } from "react-bootstrap";
import { FaFileCsv, FaFileExcel } from "react-icons/fa";
import api from "../../services/api";

class ExportCSVExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { value: "id", label: "ID" },
        { value: "nome", label: "Nome" },
        { value: "cpf_cnpj", label: "CPF/CNPJ" },
        { value: "email", label: "Email" },
        { value: "razao_social", label: "Razão Social" },
        { value: "nome_fantasia", label: "Nome Fantasia" },
        { value: "tipo_pessoa", label: "Tipo de Pessoa" },
        { value: "telefone", label: "Telefone" },
        { value: "celular", label: "Celular" },
        { value: "endereco", label: "Endereço" },
        { value: "cidade", label: "Cidade" },
        { value: "uf", label: "UF" },
        { value: "programa__nome", label: "Programa" },
        { value: "cliente__nome", label: "Cliente" },
        {
          value: "categoria_multiprofissional__nome",
          label: "Categoria Multiprofissional",
        },
        { value: "data_criacao", label: "Data de Criação" },
        { value: "mentor", label: "Mentor" },
      ],
      selectedColumns: [
        { value: "id", label: "ID" },
        { value: "nome", label: "Nome" },
        { value: "cpf_cnpj", label: "CPF/CNPJ" },
        { value: "email", label: "Email" },
        { value: "razao_social", label: "Razão Social" },
        { value: "nome_fantasia", label: "Nome Fantasia" },
        { value: "tipo_pessoa", label: "Tipo de Pessoa" },
        { value: "programa__nome", label: "Programa" },
        { value: "data_criacao", label: "Data de Criação" },
      ],
      exportFormat: "csv",
      showModal: false,
      allFieldsChecked: false,
    };
  }

  handleAllFieldsToggle = () => {
    const { allFieldsChecked, columns } = this.state;
    this.setState({
      allFieldsChecked: !allFieldsChecked,
      selectedColumns: !allFieldsChecked ? columns : [],
    });
  };

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  handleExport = () => {
    const { selectedColumns, exportFormat } = this.state;

    if (selectedColumns.length === 0) {
      alert("Por favor, selecione ao menos uma coluna.");
      return;
    }

    const selectedValues = selectedColumns.map((col) => col.value);

    api
      .post(
        "/export-prestadores-data/",
        { columns: selectedValues, format: exportFormat },
        { responseType: "blob" }
      )
      .then((response) => {
        const fileName =
          exportFormat === "csv" ? "relatorio de prestadores.csv" : "relatorio de prestadores.xlsx";
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        this.toggleModal();
      })
      .catch((error) => {
        console.error(`Erro ao exportar ${exportFormat.toUpperCase()}:`, error);
      });
  };

  render() {
    const { showModal, columns, selectedColumns, exportFormat } = this.state;

    return (
      <>
        <Button variant="light" size="sm" onClick={this.toggleModal}>
          <FaFileCsv /> {i18n.t('common:export.csvExcel')}
        </Button>

        <Modal show={showModal} onHide={this.toggleModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>{i18n.t('common:export.csvExcel')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{i18n.t('common:export.selectColumns')}</p>
            <div className="mb-3">
              <input
                type="checkbox"
                id="all-fields"
                checked={this.state.allFieldsChecked}
                onChange={this.handleAllFieldsToggle}
              />
              <label htmlFor="all-fields" className="ms-2">
                {i18n.t('common:export.allFields')}
              </label>
            </div>
            <Select
              options={columns}
              isMulti
              onChange={(selected) =>
                this.setState({
                  selectedColumns: selected,
                  allFieldsChecked: false,
                })
              }
              value={selectedColumns}
              placeholder={i18n.t('common:export.columnsPlaceholder')}
              className="mb-3"
            />
            <Form>
              <Form.Group>
                <Form.Label>{i18n.t('common:export.format')}</Form.Label>
                <Form.Check
                  type="radio"
                  label="CSV"
                  name="exportFormat"
                  value="csv"
                  checked={exportFormat === "csv"}
                  onChange={(e) =>
                    this.setState({ exportFormat: e.target.value })
                  }
                />
                <Form.Check
                  type="radio"
                  label="Excel"
                  name="exportFormat"
                  value="excel"
                  checked={exportFormat === "excel"}
                  onChange={(e) =>
                    this.setState({ exportFormat: e.target.value })
                  }
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.toggleModal}>
              {i18n.t('common:button.cancel')}
            </Button>
            <Button variant="primary" onClick={this.handleExport}>
              {i18n.t('common:export.export')}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default ExportCSVExcel;